/**
 * @license Angular v18.2.13
 * (c) 2010-2024 Google LLC. https://angular.io/
 * License: MIT
 */

import { ɵ$localize } from '@angular/localize';
export { ɵ$localize as $localize } from '@angular/localize';

// Attach $localize to the global context, as a side-effect of this module.
globalThis.$localize = ɵ$localize;
